import {
  GET_YOUTUBE_SHORT_VIDEOS,
  GET_YOUTUBE_SHORT_VIDEOS_SUCCESS,
  GET_YOUTUBE_SHORT_VIDEOS_FAIL,
  GET_YOUTUBE_SHORT_VIDEO_DETAILS,
  GET_YOUTUBE_SHORT_VIDEO_DETAILS_SUCCESS,
  GET_YOUTUBE_SHORT_VIDEO_DETAILS_FAIL,
  CREATE_YOUTUBE_SHORT_VIDEO,
  CREATE_YOUTUBE_SHORT_VIDEO_SUCCESS,
  CREATE_YOUTUBE_SHORT_VIDEO_FAIL,
  UPDATE_YOUTUBE_SHORT_VIDEO,
  UPDATE_YOUTUBE_SHORT_VIDEO_SUCCESS,
  UPDATE_YOUTUBE_SHORT_VIDEO_FAIL,
  DELETE_YOUTUBE_SHORT_VIDEO,
  DELETE_YOUTUBE_SHORT_VIDEO_SUCCESS,
  DELETE_YOUTUBE_SHORT_VIDEO_FAIL,
 
} from "./actionTypes"

const INIT_STATE = {

  shorts: {
    shorts: [],
    total: "",
    page: "",
  },
  youtubeShortVideoDetails: {},
  error: {},
  loading: false,
}

const YoutubeShortVideo = (state = INIT_STATE, action) => {
  switch (action.type) {
    // YoutubeShortVideo - This line cannot be edited or removed
    case GET_YOUTUBE_SHORT_VIDEOS:
    case GET_YOUTUBE_SHORT_VIDEO_DETAILS:
    case CREATE_YOUTUBE_SHORT_VIDEO:
    case UPDATE_YOUTUBE_SHORT_VIDEO:
    case DELETE_YOUTUBE_SHORT_VIDEO:
      return {
        ...state,
        loading: true,
      }

    case DELETE_YOUTUBE_SHORT_VIDEO_FAIL:
    case GET_YOUTUBE_SHORT_VIDEOS_FAIL:
    case GET_YOUTUBE_SHORT_VIDEO_DETAILS_FAIL:
    case UPDATE_YOUTUBE_SHORT_VIDEO_FAIL:
    case CREATE_YOUTUBE_SHORT_VIDEO_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_YOUTUBE_SHORT_VIDEOS_SUCCESS:
      return {
        ...state,
        shorts: action.payload,
        error: {},
        loading: false,
      }

    case GET_YOUTUBE_SHORT_VIDEO_DETAILS_SUCCESS:
      return {
        ...state,
        youtubeShortVideoDetails: action.payload,
        error: {},
        loading: false,
      }

    case CREATE_YOUTUBE_SHORT_VIDEO_SUCCESS:
      return {
        ...state,
        shorts: {
          ...state.shorts,
          shorts: [action.payload, ...state.shorts.shorts],
          total: state.shorts.total + 1,
        },
        youtubeShortVideoDetails: action.payload,
        error: {},
        loading: false,
      }

    case UPDATE_YOUTUBE_SHORT_VIDEO_SUCCESS:
      return {
        ...state,
        shorts: {
          ...state.shorts,
          shorts: state.shorts.shorts.map(client =>
            client._id === action.payload._id
              ? { ...client, ...action.payload }
              : client
          ),
        },
        youtubeShortVideoDetails: action.payload,
        loading: false,
        error: {},
      }

    case DELETE_YOUTUBE_SHORT_VIDEO_SUCCESS:
      return {
        ...state,
        shorts: {
          ...state.shorts,
          shorts: state.shorts.shorts.filter(
            client => client._id !== action.payload._id
          ),
        },
        error: {},
        loading: false,
      }

    default:
      return state
  }
}

export default YoutubeShortVideo
